import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {
  private activeMenu = new BehaviorSubject<number | null>(null);
  activeMenu$ = this.activeMenu.asObservable();

  setActiveMenu(userId: number | null) {
    this.activeMenu.next(userId);
  }
}